const De = {
    CustomEvent: "ce",
    Pr: "p",
    Mu: "pc",
    cc: "ca",
    Ka: "i",
    qs: "ie",
    P: "cci",
    T: "ccic",
    $: "ccc",
    H: "ccd",
    Wl: "ss",
    xl: "se",
    Vi: "si",
    Li: "sc",
    Qi: "sbc",
    Ki: "sfe",
    eo: "iec",
    Lu: "lr",
    Tu: "uae",
    R: "ci",
    B: "cc",
    Ru: "lcaa",
    Pu: "lcar",
    Xn: "inc",
    Jn: "add",
    Qn: "rem",
    Hn: "set",
    Kn: "ncam",
    Nu: "sgu",
    Fr: "ffi",
  },
  Be = { Br: "feed_displayed", dc: "content_cards_displayed" };
export { De as EventTypes, Be as InternalEventTypes };
